module.exports = __webpack_public_path__ + "static/media/tejado.23e4a402.png";